import * as ArrowRight from "@src/shared/assets/images/arrow.inline.svg";
import Button from "@src/shared/button/Button";
import styled from "styled-components";

export const Root = styled.div`
    padding: 10px 0 10px 0;
    background: white;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        margin: 30px 0;
        padding: 0 0 30px 0;
        border: 1px solid ${({ theme }) => theme.colors.backgroundLightGray};
    }
`;

export const Headline = styled.h3`
    display: inline-block;
    width: 100%;
    padding: 0 20px;
    margin: 20px 0 15px 0;
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    font-size: 20px;
    line-height: 34px;
    font-weight: 500;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 0 30px;
    }
`;

export const SearchHeadline = styled(Headline)`
    display: none;
    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: inline-block;
    }
`;

export const MobileSearchHeadline = styled(Headline)`
    margin: 0;
    ${({ theme }) => theme.breakpoints.md.mediaquery} {
        display: none;
    }
`;

export interface IFilterProps {
    open: boolean;
}

export const Filter = styled.div<IFilterProps>`
    display: ${({ open }) => (open ? "block" : "none")};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: white;
    overflow-y: auto;
    padding-bottom: 40px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: block;
        position: static;
        padding-bottom: 0;
        overflow-y: visible;
    }
`;

export const FilterActions = styled.div`
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    padding: 20px 8px;
    background: white;
    color: ${({ theme }) => theme.colors.porscheBankBlue};

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: none;
    }
`;

export const FilterGroup = styled.div`
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    padding-bottom: 30px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        border: none;
        padding-bottom: 15px;
    }
`;

export const MobileHeader = styled.header`
    margin-top: 20px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: none;
    }
`;

export const Stats = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
    gap: 5px;
`;

export const Stat = styled.div`
    cursor: pointer;
    flex-basis: calc(33% - 5px);
`;

export const StatHeadline = styled.h3`
    font-size: 16px;
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    margin: 0;
    line-height: 22px;
    margin-bottom: 10px;
`;

export const StatDescription = styled.span`
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.porscheBankBlue};
`;

export const ShowResultsButton = styled.div`
    width: 100%;
    padding: 0 20px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        width: 100%;
        padding: 0 30px;
    }
`;

export const ResetButton = styled.div`
    display: block;
    margin-top: 10px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: none;
    }
`;

export const ResetButtonText = styled.span`
    text-transform: uppercase;
`;

export const LinkArrow = styled(ArrowRight)`
    display: block;
    width: 24px;
    height: 24px;
    fill: white;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        margin-right: 20px;
    }
`;

export const AdjustFilterButton = styled.div`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: none;
    }
`;

export const FilterButton = styled(Button)`
    text-transform: uppercase;
`;

export const MobileContainer = styled.div`
    margin-bottom: 20px;
    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: none;
    }
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Col = styled.div`
    width: calc(50% - 3px);
`;

export const FilterMessage = styled.p`
    font-size: 12px;
`;

export const SliderFilterContainer = styled.div`
    padding: 20px 0;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 0 30px;
    }
`;
